import { render } from "./index.vue?vue&type=template&id=08e57993&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=08e57993&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e57993"],['__file',"src/vab/layouts/VabLayoutVertical/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08e57993"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08e57993', __exports__)) {
    console.log('reload')
    api.reload('08e57993', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=08e57993&scoped=true", () => {
    console.log('re-render')
    api.rerender('08e57993', render)
  })

}


export default __exports__